module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "inp-modal modal fade noselect",
    attrs: {
      "id": "modalCardActivity"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content",
    attrs: {
      "data-testid": "notesCard-modal"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('span', {
    staticClass: "title",
    attrs: {
      "data-testid": "notesCard-modal-title"
    }
  }, [_vm._v(_vm._s(_vm.getTitle()))]), _vm._v(" "), _c('button', {
    staticClass: "close",
    attrs: {
      "disabled": !_vm.dataReady,
      "data-testid": "notesCard-modal-close-button",
      "aria-label": "Close",
      "data-dismiss": "modal",
      "title": "Fermer",
      "type": "button"
    }
  }, [_c('span', {
    staticClass: "fas fa-times"
  })])]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.enregistrer($event)
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "tw-flex tw-flex-row",
    class: {
      'tw-hidden': !_vm.isEdit
    }
  }, [_c('div', {
    staticClass: "tw-grow"
  }, [_c('input-text', {
    staticClass: "tw-mb-3",
    attrs: {
      "disabled": !_vm.dataReady,
      "data-testid": "notesCard-modal-noteTitle-input",
      "required": true,
      "show": _vm.isEdit,
      "vmodel": _vm.titre,
      "label": "Titre",
      "length": "100"
    },
    on: {
      "update:vmodel": function($event) {
        _vm.titre = $event
      }
    }
  }), _vm._v(" "), _c('input-text', {
    attrs: {
      "disabled": !_vm.dataReady,
      "data-testid": "notesCard-modal-noteDetail-input",
      "required": true,
      "show": _vm.isEdit,
      "textarea": true,
      "vmodel": _vm.details,
      "label": "Détail",
      "length": "1000",
      "rows": "10"
    },
    on: {
      "update:vmodel": function($event) {
        _vm.details = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-w-[190px] tw-ml-3"
  }, [_c('div', {
    staticClass: "tw-h-[43px] tw-flex tw-mb-3 tw-items-center"
  }, [_c('checkbox', {
    attrs: {
      "disabled": !_vm.dataReady,
      "data-testid": "notesCard-modal-startDate-checkbox",
      "label": !_vm.enableDateDebut ? 'Date de début' : '',
      "vmodel": _vm.enableDateDebut,
      "title": "Détermine une date de début à laquelle la note doit apparaitre"
    },
    on: {
      "update:vmodel": function($event) {
        _vm.enableDateDebut = $event
      }
    }
  }), _vm._v(" "), _c('input-date', {
    attrs: {
      "disabled": !_vm.dataReady,
      "data-testid": "notesCard-modal-startDate-input",
      "required": true,
      "show": _vm.enableDateDebut,
      "vmodel": _vm.dateDebut,
      "label": "Date de début"
    },
    on: {
      "update:vmodel": function($event) {
        _vm.dateDebut = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-h-[43px] tw-flex tw-mb-3 tw-items-center"
  }, [_c('checkbox', {
    attrs: {
      "disabled": !_vm.dataReady,
      "data-testid": "notesCard-modal-endDate-checkbox",
      "label": !_vm.enableDateFin ? 'Date de fin' : '',
      "vmodel": _vm.enableDateFin,
      "title": "Détermine une date de fin à laquelle la note doit disparaitre"
    },
    on: {
      "update:vmodel": function($event) {
        _vm.enableDateFin = $event
      }
    }
  }), _vm._v(" "), _c('input-date', {
    attrs: {
      "disabled": !_vm.dataReady,
      "data-testid": "notesCard-modal-endDate-input",
      "required": true,
      "show": _vm.enableDateFin,
      "vmodel": _vm.dateFin,
      "label": "Date de fin"
    },
    on: {
      "update:vmodel": function($event) {
        _vm.dateFin = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-h-[43px] tw-mb-3 tw-flex tw-items-center"
  }, [_c('checkbox', {
    attrs: {
      "label": "Minimiser le détail",
      "data-testid": "notesCard-modal-minify-checkbox",
      "title": "Permet de ne voir que l'apercu du détail dans l'écran d'accueil",
      "disabled": !_vm.dataReady,
      "vmodel": _vm.enableFullPreview
    },
    on: {
      "update:vmodel": function($event) {
        _vm.enableFullPreview = $event
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tw-h-[43px] tw-flex tw-items-center",
    attrs: {
      "data-testid": "notesCard-modal-important-checkbox"
    }
  }, [_c('checkbox', {
    attrs: {
      "label": "Note importante",
      "data-testid": "notesCard-modal-important-checkbox",
      "title": "Permet de voir la note en mode important (rouge)",
      "disabled": !_vm.dataReady,
      "vmodel": _vm.enableImportant
    },
    on: {
      "update:vmodel": function($event) {
        _vm.enableImportant = $event
      }
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    class: {
      'tw-hidden': _vm.isEdit
    }
  }, [(_vm.dateDebut || _vm.dateFin) ? _c('div', {
    staticClass: "tw-flex mb-3"
  }, [(_vm.dateDebut) ? _c('div', {
    staticClass: "tw-text-xs tw-bg-black/40 tw-px-2 tw-py-1 tw-rounded tw-text-white tw-mr-2"
  }, [_vm._v("\n                                À partir du :\n                                "), _c('span', {
    staticClass: "tw-font-bold"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.dateDebut, "DD/MM/YY")))])]) : _vm._e(), _vm._v(" "), (_vm.dateFin) ? _c('div', {
    staticClass: "tw-text-xs tw-bg-black/40 tw-px-2 tw-py-1 tw-rounded tw-text-white"
  }, [_vm._v("\n                                Jusqu'au :\n                                "), _c('span', {
    staticClass: "tw-font-bold"
  }, [_vm._v(_vm._s(_vm._f("moment")(_vm.dateFin, "DD/MM/YY")))])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "tw-text-2xl tw-font-bold tw-uppercase tw-mb-1"
  }, [_vm._v("\n                            " + _vm._s(_vm.titre) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "tw-mb-3 tw-leading-5"
  }, [_vm._v(_vm._s(_vm.details))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer tw-mt-5"
  }, [_c('div', {
    staticClass: "area-action"
  }, [_c('button', {
    staticClass: "inp-button-modal valid",
    attrs: {
      "disabled": !_vm.dataReady,
      "data-testid": "notesCard-modal-save",
      "type": "submit"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("Valider")])]), _vm._v(" "), (_vm.isEdit || _vm.estAjout) ? _c('button', {
    staticClass: "inp-button-modal cancel ml-1",
    attrs: {
      "data-testid": "notesCard-modal-cancel",
      "disabled": !_vm.dataReady,
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.annuler()
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("Annuler")])]) : _vm._e()])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hide"
  }, [_c('span', {
    staticClass: "fas fa-check"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hide"
  }, [_c('span', {
    staticClass: "fas fa-times"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-17c37cd7"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home/modals/modalCardActivity/modalCardActivity.vue.html
// module id = AwbR
// module chunks = 2